import React from 'react';
import {
    BaseToolbarDimension,BaseToolbarMarginOrPadding, BaseToolbarInputGroup, BaseInput, BaseToolbarSelect, BaseToolbarJson,
} from 'wsc-react-custom-form';
export const Settings = () => {
    return (
        <React.Fragment>

            <BaseToolbarInputGroup>

                <BaseInput propKey='name' label='Name' tooltipTitle='存储表单值的key' widthRation={50}/>
                <BaseInput propKey='label' label='Label' tooltipTitle='标签' widthRation={50}/>
                <BaseToolbarSelect
                    propKey='required'
                    label='必填项'
                    tooltipTitle='是否为必填项'
                    options={[
                        {value: 'true', label: '是'},
                        {value: 'false', label: '否'}
                    ]}
                    widthRation={50}
                />
                <BaseToolbarJson propKey="rules"  label='校验规则'  tooltipTitle='表单组件的校验规则' widthRation={50}/>

                <BaseToolbarSelect
                    propKey='disabled'
                    label='禁用编辑'
                    tooltipTitle='是否禁用表单组件'
                    options={[
                        {value: 'true', label: '禁用'},
                        {value: 'false', label: '不禁用'}
                    ]}
                    widthRation={50}
                />
                <BaseToolbarSelect
                    propKey='visible'
                    label='可见'
                    tooltipTitle='是否显示表单组件'
                    options={[
                        {value: 'true', label: '是'},
                        {value: 'false', label: '否'}
                    ]}
                    widthRation={50}
                />
          
                <BaseToolbarSelect
                    propKey='isNewLine'
                    label='标签位置'
                    tooltipTitle='组件标签和组件位置关系'
                    options={[
                        {value: 'true', label: '垂直'},
                        {value: 'false', label: '水平'}
                    ]}
                    widthRation={50}
                />
                <BaseToolbarSelect
                    propKey='border'
                    label='底部边框'
                    tooltipTitle='是否显示组件边框'
                    options={[
                        {value: 'true', label: '是'},
                        {value: 'false', label: '否'}
                    ]}
                    widthRation={50}
                />

                <BaseInput propKey='labelSpan' label='labelSpan' tooltipTitle='标签宽度（labelSpan）' widthRation={50}/>
                <BaseInput propKey='labelOffset' label='labelOffset' tooltipTitle='标签偏移量（labelOffset）' widthRation={50} />
                <BaseInput propKey='wrapperSpan' label='wrapperSpan' tooltipTitle='表单组件宽度（wrapperSpan）' widthRation={50} />
                <BaseInput propKey='wrapperOffset' label='wrapperOffset' tooltipTitle='表单组件偏移量（wrapperOffset）' widthRation={50} />
            </BaseToolbarInputGroup>
        </React.Fragment>
    );
};
